// biome-ignore-all lint/style/useNamingConvention: exisiting error

export const GalleryAssetName: Record<string, Record<string, string>> = {
  desktop: {
    composed: '800x600',
    standalone_legacy: '500x680_optimized',
    standalone: 'medium_gallery_asset',
    uyo_mask_legacy: '500x680_uyo_mask',
    uyo_mask: 'medium_uyo_mask',
  },
  mobile: {
    composed: '496x372',
    standalone_legacy: '250x340_optimized',
    standalone: 'small_gallery_asset',
    uyo_mask_legacy: '250x340_uyo_mask',
    uyo_mask: 'small_uyo_mask',
  },
};
